// Vuex module for handling message notifications
const state = {
  unreadCount: 0,
  messages: []
}

const mutations = {
  SET_UNREAD_COUNT(state, count) {
    state.unreadCount = count
  },
  SET_MESSAGES(state, messages) {
    state.messages = messages
  },
  MARK_AS_READ(state, messageId) {
    const message = state.messages.find(msg => msg.id === messageId)
    if (message) {
      message.is_read = 1
      state.unreadCount = Math.max(0, state.unreadCount - 1)
    }
  },
  MARK_ALL_READ(state) {
    state.messages.forEach(msg => {
      msg.is_read = 1
    })
    state.unreadCount = 0
  }
}

const actions = {
  // 获取未读消息数量
  getUnreadCount({ commit }) {
    return new Promise((resolve, reject) => {
      import('@/utils/http').then(module => {
        const http = module.default
        http.getRequest('/api/ajax/unreadMessageCount')
          .then(res => {
            if (res.code === 200) {
              commit('SET_UNREAD_COUNT', res.data || 0)
            }
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  
  // 获取消息列表
  getMessages({ commit }) {
    return new Promise((resolve, reject) => {
      import('@/utils/http').then(module => {
        const http = module.default
        http.getRequest('message/index')
          .then(res => {
            if (res.code === 200) {
              commit('SET_MESSAGES', res.data.data || [])
              // 更新未读消息数量
              const unreadCount = (res.data.data || []).filter(msg => msg.is_read === 0).length
              commit('SET_UNREAD_COUNT', unreadCount)
            }
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  
  // 标记消息为已读
  markAsRead({ commit }, messageId) {
    commit('MARK_AS_READ', messageId)
  },
  
  // 标记所有消息为已读
  markAllRead({ commit }) {
    commit('MARK_ALL_READ')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
} 